<template>
  <div class="transactions">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
    </v-row>
    <monthly-service-charge-details-card
      :monthly-service-charge="details"
      :is-loading="isLoading"
    /><br>
    <monthly-service-charge-payment-details-card
      :monthly-service-charge-payments="details.monthly_service_charge_payments"
      :is-loading="isLoading"
    /><br>
    <user-details-card
      :user="details.user"
      :is-loading="isLoading"
    />
  </div>
</template>
<script>
import axios from 'axios'
import MonthlyServiceChargeDetailsCard from '@/components/details-card/MonthlyServiceChargeDetailsCard.vue'
import MonthlyServiceChargePaymentDetailsCard from '@/components/details-card/MonthlyServiceChargePaymentDetailsCard.vue'
import UserDetailsCard from '@/components/details-card/UserDetailsCard.vue'
import BreadCrumb from '@/components/partials/BreadCrumb.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    UserDetailsCard,
    MonthlyServiceChargeDetailsCard,
    MonthlyServiceChargePaymentDetailsCard,
  },
  data() {
    return {
      search: '',
      details: { user: {}, monthly_service_charge_payments: [] },
      isLoading: false,
      meterReadingId: this.$route.params.id,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Monthly Service Fee',
          disabled: false,
          to: { name: 'monthly-service-charge' },
        },
      ],
    }
  },
  mounted() {
    this.getDetails()
    if (this.meterReadingId) {
      this.breadcrumbs.push(
        {
          text: this.meterReadingId,
          disabled: true,
          to: { name: 'monthly-service-charge-details' },
        },
      )
    }
  },
  methods: {
    getDetails() {
      this.isLoading = true
      axios
        .get(`monthly-service-charges/${this.meterReadingId}`)
        .then(response => {
          this.details = response.data
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$notification.error(error.response.data.message)
        })
    },
  },
}
</script>
